import React, { useState } from 'react';
import { Banner, Button, Form, FormLayout, Modal, TextField } from '@shopify/polaris';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';

const NewAccountantModal = (props) => {
  const [clientData, setStaffData] = useState({
    firstName: '',
    lastName: '',
    email: ''
  });
  const [showNewStaff, setShowNewStaff] = useState(true);
  const [formErrors, setFormErrors] = useState({});

  const { t } = useTranslation();

  const closeModal = () => {
    setStaffData({ ...clientData, firstName: '', lastName: '', email: '' });
    setShowNewStaff(false);
    props.close();
  };

  const handleChange = (field) => (value) => setStaffData({ ...clientData, [field]: value });

  const onSubmit = () => {
    setFormErrors({});

    if (!formValid()) return;

    const accountant = {
      first_name: clientData.firstName,
      last_name: clientData.lastName
    };

    if (clientData.email) {
      accountant.email = clientData.email;
    }

    props.handleSubmit({ accountant });
    props.close();
  };

  const formValid = () => {
    const e = {};
    if (!clientData.firstName) {
      e.firstName = t('user.validations.first_name');
    }
    if (!clientData.lastName) {
      e.lastName = t('user.validations.last_name');
    }
    if (!clientData.email) {
      e.email = t('user.validations.email');
    }

    setFormErrors(e);
    return Object.entries(e).length === 0;
  };

  return (
    <Modal
      open={showNewStaff}
      onClose={closeModal}
      title={props.title}
    >
      <Modal.Section>
        <Form onSubmit={onSubmit}>
          <FormLayout>
            <Banner title={t('staff-accounts')} status="info">
              <p>{t('accountant.new_desc')}</p>
            </Banner>
            <TextField error={formErrors.firstName} label={t('user.first_name')} value={clientData.firstName} onChange={handleChange('firstName')} />
            <TextField error={formErrors.lastName} label={t('user.last_name')} value={clientData.lastName} onChange={handleChange('lastName')} />
            <TextField error={formErrors.email} label={t('user.email')} type="email" value={clientData.email} onChange={handleChange('email')} />
            <Button primary submit>{t('shared.add')}</Button>
          </FormLayout>
        </Form>
      </Modal.Section>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  isInstructor: state.auth.instructor
});

export default connect(mapStateToProps)(NewAccountantModal);
